import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { imgSvg } from '../card-skeleton/card-skeleton.component';
import { input } from '@angular/core';

@Component({
  selector: 'ngx-horizontal-skeleton',
  standalone: true,
  imports: [CommonModule],

  template: `
    <div role="status" class=" animate-pulse  space-x-8 flex items-center">
      <div
        *ngIf="image()"
        class="flex justify-center items-center w-full h-48 bg-gray-300 rounded-2xl sm:w-96 dark:bg-gray-700"
      >
        ${imgSvg}
      </div>
      <div class="w-full">
        <div
          class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"
        ></div>
        <div
          class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[480px] mb-2.5"
        ></div>
        <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
        <div
          class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[440px] mb-2.5"
        ></div>
        <div
          class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[460px] mb-2.5"
        ></div>
        <div
          class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 max-w-[360px]"
        ></div>
      </div>
      <span class="sr-only">Loading...</span>
    </div>
  `,
  styles: [],
})
export class HorizontalSkeletonComponent {
  image = input(true);
}
